export class UserListingModel 
{
    PageNumber: number = 1;
    PageSize: number = 10;
    KeyWord: string = "";
}

export class UserList{
    firstName: string;
    lastName: string;
    email: string;
    roletype: string;
    isActive: boolean;
    isVerified: boolean;
}

export class UserResponseModel 
{
    UserList: Array<UserList> = [];
    TotalPages: number;
}